import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=1a4cc878&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=1a4cc878&lang=scss&scoped=true&"
import style1 from "./EventDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4cc878",
  null
  
)

export default component.exports